function closeModel(dom) {
  $('.giftList-list').scrollTop(0);
  $('#drawsNumberValue').val('')
  document.body.classList.remove('no-scroll');
  $(dom).hide()
}
function clickProfile(params) {
  let dom = $(`#item-${params + 1}`)
  $('.myProfile-detail').removeClass('active');
  $(dom).addClass('active')
  $('.myProfile-item').removeClass('active');
  $('.myProfile-item').eq(params).addClass('active');
}
$(document).ready(function() {
    const $prevMonthBtn = $('#prevMonth');
    const $nextMonthBtn = $('#nextMonth');
    const $monthYearElem = $('#monthYear');
    const $daysElem = $('#days');

    let currentDate = new Date(); // 当前日期
    let currentMonth = currentDate.getMonth();
    let currentYear = currentDate.getFullYear();

    function addCreditDiv() {
        $('#days .date').each(function() {
            const creditDiv = $('<div class="credit">CREDITS<br/><span style="font-size: 20px;font-weight: bold;">100</span></div>');
            $(this).before(creditDiv);
        });
    }

    function formatDate(date) {
        return date.toLocaleDateString('zh-CN', { day: '2-digit', month: '2-digit' });
    }

    function isTodayInRange(startDate, endDate) {
        const today = new Date();
        return today >= startDate && today <= endDate;
    }

    function adjustStartDate() {
        let firstDay = new Date(currentYear, currentMonth, 1).getDay();
        let startDate = new Date(currentYear, currentMonth, 1 - firstDay);
        let endDate = new Date(startDate);
        endDate.setDate(startDate.getDate() + 34);

        if (!isTodayInRange(startDate, endDate)) {
            // 如果今天不在范围内，跳到下个月
            currentMonth++;
            if (currentMonth > 11) {
                currentMonth = 0;
                currentYear++;
            }
        }
    }

    function renderCalendar() {
        const isWideScreen = $(window).width() > 540;
        $daysElem.empty();

        if (isWideScreen) {
            let firstDay = new Date(currentYear, currentMonth, 1).getDay();
            $monthYearElem.text(`${currentYear}-${currentMonth + 1}`);

            let startDate = new Date(currentYear, currentMonth, 1 - firstDay);
            let endDate = new Date(startDate);
            endDate.setDate(startDate.getDate() + 34);

            for (let date = new Date(startDate); date <= endDate; date.setDate(date.getDate() + 1)) {
                addDateElement(date);
            }
        } else {
            let date = new Date(currentDate);
            $monthYearElem.text(`${date.getFullYear()}-${date.getMonth() + 1}`);

            for (let i = 0; i < 7; i++) {
                date.setDate(currentDate.getDate() + i);
                addDateElement(date);
            }
        }
        addCreditDiv();
        checkInit();
    }

    function addDateElement(date) {
        const formattedMonth = String(date.getMonth() + 1).padStart(2, '0');
        const formattedDay = String(date.getDate()).padStart(2, '0');
        const time = `${date.getFullYear()}-${formattedMonth}-${formattedDay}`;
        const htmlItem = $(`<div class="date" data-date="${time}">${formatDate(date)}</div>`);

        const weekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        const weekDayIndex = date.getDay();
        const weekDay = weekdays[weekDayIndex];

        const dayElem = $('<div></div>').html(htmlItem).attr('data-week', weekDay);
        if (date.getMonth() !== currentMonth) {
            dayElem.addClass('empty');
        } else if (date.toDateString() === new Date().toDateString()) {
            const TodayItem = $(`<div data-date="${time}" class="date">Today</div>`);
            dayElem.attr('onclick', `signClick('${time}', 'today')`);
            dayElem.addClass('today').html(TodayItem);
        }
        $daysElem.append(dayElem);
    }

    $prevMonthBtn.click(function() {
        if ($(window).width() > 540) {
            if (currentMonth === 0) {
                currentMonth = 11;
                currentYear--;
            } else {
                currentMonth--;
            }
        } else {
            currentDate.setDate(currentDate.getDate() - 7);
        }
        renderCalendar();
    });

    $nextMonthBtn.click(function() {
        if ($(window).width() > 540) {
            if (currentMonth === 11) {
                currentMonth = 0;
                currentYear++;
            } else {
                currentMonth++;
            }
        } else {
            currentDate.setDate(currentDate.getDate() + 7);
        }
        renderCalendar();
    });

    adjustStartDate(); // **初始化时检查是否跳到下个月**
    renderCalendar(); // **渲染日历**
});

function showxMareket(params) {
  modalTag('#xMareket', params)
}
function modalTag(a, b) {
  // 假设 'a' 是一个选择器或 jQuery 对象，'b' 是索引
  let $items = $(a).find('.modal-item');
  $(a).show()
  // 移除所有项的 'active' 类
  $items.removeClass('active');
  
  // 为指定索引的项添加 'active' 类
  $items.eq(b).addClass('active');
  console.log(b)
  $('.xMareket-reward').hide()
  $('.xMareket-credits').hide()
  if(b === 0) {
    $('.xMareket-credits').show()
  } else {
    $('.xMareket-reward').show()
  }
}
$(document).ready(function() {
  const list = document.querySelector('.continuousSignature-list');
  const wrapper = document.querySelector('.continuousSignature-wrapper');
  let offset = 0;
  
  document.querySelector('.arrow-up').addEventListener('click', () => {
    offset += 120;
    if (offset > 0) offset = 0; // 不允许超出顶部
    list.style.transform = `translateY(${offset}px)`;
  });
  
  document.querySelector('.arrow-down').addEventListener('click', () => {
    offset -= 120;
    const maxOffset = list.scrollHeight - wrapper.clientHeight;
    console.log(wrapper.scrollHeight)
    console.log(maxOffset)
    if (offset < -maxOffset) offset = -maxOffset; // 不允许超出底部
    list.style.transform = `translateY(${offset}px)`;
  });
});
$(document).ready(function() {
  const urlParams = new URLSearchParams(window.location.search);
  const id = urlParams.get('id');
  
  // 使用 jQuery 显示对应的元素
  if (id) {
    $("#" + id).show();
    modalTag('#xMareket', 1)
    urlParams.delete('id');
    window.history.replaceState({}, '', `${location.pathname}?${urlParams}`);
  }
   $.ajax({
     url: "https://nxtcity.nxtbrands.com/frontapi/indexPage/info",
     type: "GET",
     data: {}, 
     dataType: "json", 
     success: function (result) {
       const {data} = result
       const {info, dataVersion,monthcardBenefit} = data
        // 获取包含换行符的文本
        let textWithNewLines = monthcardBenefit?.equityStatement;
        $('.monthlyRules-button').attr('href', monthcardBenefit.redirectGoodsLink);
        // 替换换行符为 <br> 标签
        let htmlContent = textWithNewLines?.replace(/\n/g, '<br>');
        
        // 设置 HTML 内容
        $('.monthlyRules-text-membership').html(htmlContent);
     }
  })
});
$(document).ready(function () {
  function getEndOfWeek() {
    // 获取当前日期
    const now = new Date();
    // 计算距离周日还有几天
    const daysUntilSunday = 7 - now.getDay(); 
    // 本周结束的时间为下一个周一的 00:00:00
      const endOfWeek = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() + daysUntilSunday));
    return endOfWeek;
  }

  function updateCountdown() {
    const now = new Date();
    const endOfWeek = getEndOfWeek();
    const timeRemaining = endOfWeek - now;

    if (timeRemaining > 0) {
      const seconds = Math.floor((timeRemaining / 1000) % 60);
      const minutes = Math.floor((timeRemaining / 1000 / 60) % 60);
      const hours = Math.floor((timeRemaining / (1000 * 60 * 60)) % 24);
      const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));

      $('.countdown').html(`Ends in <span>${days}</span> days <span>${hours.toString().padStart(2, '0')}</span>:<span>${minutes.toString().padStart(2, '0')}</span>:<span>${seconds.toString().padStart(2, '0')}</span>`);
    } else {
      $('.countdown').text('This week has ended!');
    }
  }

  // 每秒更新倒计时
  setInterval(updateCountdown, 1000);
  // 初始化显示
  updateCountdown();
});